/// <reference types="@types/google.maps" />

import { useGoogleMap } from "./use-google-map";
import { useGoogleMapsWithHandle } from "./use-google-maps-with-handle";

export function useMapInstanceHandle(
  apiKey: string,
  mapElementRef: React.RefObject<HTMLDivElement | null>,
  opts?: google.maps.MapOptions,
) {
  const isGoogleMapLoaded = useGoogleMap(apiKey);

  return useGoogleMapsWithHandle(
    isGoogleMapLoaded,
    {
      apiKey: apiKey,
      mapElementRef,
    },
    opts,
  );
}
